/* eslint-disabled */
import ItemType from "./ItemType";
import PrintableModelExtend from "@/entity/extends/PrintableModelExtend";

export default class PrintableModel extends PrintableModelExtend {

    public id!: number;
    public label = '';
    public slug = '';
    public template? = '';
    public isPrivate?: boolean;
    public isConsentRequired?: boolean;
    public itemType!: ItemType;
    public isActive?: boolean;
    public uuid? = '';
    public createdAt?: Date;
    public updatedAt?: Date;
    public createBy? = '';
    public updateBy? = '';
    public removeBy? = '';
    public createdFromIp? = '';
    public updatedFromIp? = '';

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;
            this.label = object.label;
            this.slug = object.slug;
            this.template = object.template;
            this.isPrivate = object.isPrivate;
            this.isConsentRequired = object.isConsentRequired;
            this.itemType = (object.itemType instanceof ItemType) ? object.itemType : object.itemType ? new ItemType(object.itemType) : object.itemType;
            this.isActive = object.isActive;
            this.uuid = object.uuid;
            if (object.createdAt) {
                this.createdAt = new Date(object.createdAt);
            }
            if (object.updatedAt) {
                this.updatedAt = new Date(object.updatedAt);
            }
            this.createBy = object.createBy;
            this.updateBy = object.updateBy;
            this.removeBy = object.removeBy;
            this.createdFromIp = object.createdFromIp;
            this.updatedFromIp = object.updatedFromIp;
        }
        this.postConstruct()
    }

}
